import { useIntl } from "react-intl";

import { ReactComponent as PlusIcon } from "assets/images/iconsV2/plus.svg";
import Button from "components/v2/Button/Button";

interface AccountMappingAddButtonProps {
  onClick: () => void;
}

export default function AccountMappingAddButton({ onClick }: AccountMappingAddButtonProps) {
  const intl = useIntl();

  return (
    <div className="account-mapping-add">
      <Button
        testId="account-mapping-add"
        variant="tertiary-color"
        size="sm"
        iconLeft={<PlusIcon />}
        label={intl.formatMessage({ id: "general.add", defaultMessage: "Add" })}
        onClick={onClick}
      />
    </div>
  );
}
